import { forwardRef, ReactElement, RefObject, useState } from 'react';
import { CardMedia, DividerProps, useMediaQuery, useTheme, Typography } from '@mui/material';
import flowingCSImage from '@/assets/images/sources/flowing_cs_banner.png';

import { Box, Drawer, DrawerProps, List, Paper } from '@mui/material';
import ExpandableMenuItem from '@/layouts/ManagerLayout/ExpandableMenuItem';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import FlowingCsSvg from '@/assets/images/logo/flowing_space_logo_signiture.svg';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { useTranslation } from 'react-i18next';
import { useSpaceUserV2Store } from '@/store';
interface MenuItemBase {
    id?: string | number;
    label: string;
    icon?: ReactElement;
    to?: string;
    href?: string;
    target?: string;
    action?: () => void;
    isExistMatch?: boolean;
}

export interface MenuItem extends MenuItemBase {
    children?: MenuItemBase[] | ReactElement;
    isShowDivider?: boolean;
    DividerProps?: DividerProps;
    isActive?: boolean;
}
export interface MenuTitleListItem {
    menuTitle: string;
    menuTitleImg: any;
    menuList: MenuItem[];
}

interface Props extends DrawerProps {
    isDrawerOpen?: boolean;
    appBarHeight?: number;
    menuTitleList?: MenuTitleListItem[];
    append?: ReactElement;
}

const MenuDrawer = (props: Props, ref: any) => {
    const { isDrawerOpen = true, appBarHeight = 64, menuTitleList = [], append } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    const { grade_name } = useSpaceUserV2Store();
    const isSodomall = grade_name === '소도몰';
    const MenuTitleBox = ({ title, img = '', isMt }: { title: string; img: string; isMt: boolean }) => {
        return (
            <Box className={`flex pl-3 items-center gap-2`} sx={{ mt: isMt ? 3 : 2 }}>
                <CardMedia component={'img'} src={img} sx={{ width: '35px', height: '35px' }} />
                <Typography>
                    <b>{title}</b>
                </Typography>
            </Box>
        );
    };

    return (
        <Box>
            <Drawer
                PaperProps={{
                    ref: ref,
                    sx: {
                        minWidth: 240,
                        maxWidth: 320,
                        marginTop: `${appBarHeight}px`,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflowY: 'auto',
                        // 스크롤바 기본적으로 숨김
                        '&::-webkit-scrollbar': {
                            width: '0px',
                            background: 'transparent',
                        },
                        // 호버 시에만 스크롤바 표시
                        '&:hover::-webkit-scrollbar': {
                            width: '6px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: 'transparent',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#ccc',
                            borderRadius: '3px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: '#999',
                        },
                        // Firefox용 스크롤바 스타일링
                        scrollbarWidth: 'none',
                        '&:hover': {
                            scrollbarWidth: 'thin',
                            scrollbarColor: '#ccc transparent',
                        },
                    },
                }}
                variant={!isMobile ? 'persistent' : 'temporary'}
                hideBackdrop={true}
                open={isDrawerOpen}
                sx={{
                    flexShrink: 0,
                }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        paddingBottom: !props?.append ? `${appBarHeight}px` : undefined,
                    }}
                >
                    {menuTitleList.map((item, idx) => {
                        return (
                            <div key={idx}>
                                <MenuTitleBox title={item.menuTitle} isMt={idx !== 0} img={item.menuTitleImg} />
                                <List
                                    sx={{
                                        '& .MuiListItemIcon-root': { minWidth: 35 },
                                    }}
                                >
                                    {item.menuList.map((item, index) => {
                                        return <ExpandableMenuItem {...item} key={item?.id || index} />;
                                    })}
                                </List>
                            </div>
                        );
                    })}
                    {/* 고객센터 & 사용자 가이드 - 소도몰 역할일 때 숨김 */}
                    {!isSodomall && (
                        <List
                            sx={{
                                '& .MuiListItemIcon-root': { minWidth: 35 },
                                mt: 5,
                            }}
                        >
                            <ExpandableMenuItem
                                label={t('product.customerCenter')}
                                target="_blank"
                                href="http://pf.kakao.com/_BxfaRn/chat"
                                // href='https://help.flowing.space/hc/ko/requests/new'
                                isShowDivider
                                icon={<SupportAgentIcon />}
                            />
                            <ExpandableMenuItem
                                label={t('sidebar.userGuide')}
                                target="_blank"
                                href="https://flowing.oopy.io/guide/seller/mall"
                                // isShowDivider
                                icon={<ArticleOutlinedIcon />}
                            />
                        </List>
                    )}
                </Paper>
                {!!append ? (
                    <div
                        style={{
                            paddingBottom: appBarHeight,
                        }}
                    >
                        {append}
                    </div>
                ) : (
                    ''
                )}
            </Drawer>
        </Box>
    );
};

export default forwardRef(MenuDrawer);
